/*
 * Model for getting and updating the daily refresh schedule for a specific KB
 */

define(["backbone", "moment", "messaging/messenger", "configuration/properties"], function (
  Backbone,
  Moment,
  Messenger,
  Properties,
) {
  var KbDailyRefreshModel = {};

  KbDailyRefreshModel.kbDailyRefreshModel = Backbone.Model.extend({
    idAttribute: "refreshHourUTC", //set it as something so that we save using PUT instead of POST
    defaults: {
      dailyRefresh: false,
      refreshHourUTC: 0,
    },
    //a version of the same time select used in the learner config area
    initializeCustom: function () {
      //initialize the time dropdown to be properly i18n'ed
      //loop through the minutes of the day in timeIncrement minute increments
      this.timeOptions = [];
      var minutesPerDay = 1440;
      for (var minutes = 0; minutes < minutesPerDay; minutes += 60) {
        var time = Moment({ minute: 0 }).add("minutes", minutes);
        var timeString = Messenger.reqres.request("get:formatted:time", time);
        //get the hour of the day in local time
        var hourUTC = time.utc().hour();
        //time value is the millisecond offset from midnight to the timeString
        this.timeOptions.push({ timeValue: hourUTC, timeString: timeString });
      }
    },
    url: function () {
      var kbId = Messenger.reqres.request("active:kb");
      return Properties.rootURL + "/" + kbId + "/dailyrefresh";
    },
  });

  //get the current daily refresh info from the server
  Messenger.reqres.setHandler(
    "kb:daily:refresh:model",
    function () {
      var refreshModel = new KbDailyRefreshModel.kbDailyRefreshModel();
      refreshModel.fetch();
      return refreshModel;
    },
    this,
  );

  return KbDailyRefreshModel;
});
